import { Injectable } from '@angular/core';

/*
  Generated class for the ImageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImageProvider {

  constructor() { }


  /**** Utility - Add Text to Image  ********/
  addTextToImage(img: string, text: string): Promise<string> {
    return new Promise(resolve => {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");

      var image = new Image();
      image.src = img;
      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        ctx.beginPath();
        ctx.rect(0, 0, canvas.width, 30);
        ctx.fillStyle = "black";
        ctx.fill();

        ctx.font = "20px serif";
        ctx.fillStyle = "white";
        ctx.fillText(text, 5, 25);

        resolve(canvas.toDataURL("image/jpeg"));
      };
    });
  }

  /**** Utility - Get Base 64 from File Inpuyt  ********/
  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function(error) {
        reject(null);
      };
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/image/image.ts